"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixDoubleBackslashInColor = fixDoubleBackslashInColor;
const tex_syntax_1 = require("./tex-syntax");
const colorWithDoubleBackslashAtStart = new RegExp(`(\\\\${tex_syntax_1.color}\\{)\\\\\\\\`, "g");
function fixDoubleBackslashInColor(tex) {
    return tex.replace(colorWithDoubleBackslashAtStart, "$1");
}
